export default __webpack_public_path__ + "static/media/maure_de_bretagnemini.e4af36a0.jpg";